import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=009fb605&"
import script from "./ToDo.vue?vue&type=script&lang=js&"
export * from "./ToDo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports